import { GridColDef } from "@mui/x-data-grid";
import ProfessionDetailButton from "./DetailButton";
import CheckCell from "../components/datagrid/CheckCell";

export const professionColumns: GridColDef[] = [
    {
        field: '',
        renderCell: ProfessionDetailButton,
        width: 150,
        headerName: '',
        sortable: false,
        filterable: false,
    },
    {
        field: 'professionCode',
        minWidth: 150,
        headerName: 'Kod',
        sortable: false,
        filterable: false
    },
    {
        field: 'name',
        headerName: 'Ad',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'isDeleted',
        headerName: 'Silindi',
        flex: 1,
        minWidth: 80,
        renderCell: CheckCell
    },
];